import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
    fetchCategories,
    createCategory,
    deleteCategory
} from "../../../../utils/redux/blogCategory/blogCategoryActions";

import DynamicFormModal from "../../../Modal/DynamicFormModal/DynamicFormModal";
import { blogCategoryFields } from "../../../../helpers/InputFields/InputFields";

import { toast } from "react-toastify";

const BlogCategoryListingPage = () => {
    const dispatch = useDispatch();
    const { categories } = useSelector(state => state.blogCategory);

    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        dispatch(fetchCategories());
    }, []);

    const handleCreate = async (data) => {
        const res = await dispatch(createCategory(data));
        if (res?.success) {
            toast.success("Category added");
        } else {
            toast.error("Failed");
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Delete category?")) return;

        const res = await dispatch(deleteCategory(id));
        if (res?.success) {
            toast.success("Deleted");
        }
    };

    return (
        <div className="container">
            <div className="d-flex justify-content-between my-4">
                <h3>Blog Categories</h3>
                <button
                    className="btn btn-primary"
                    onClick={() => setShowModal(true)}
                >
                    + Add Category
                </button>
            </div>

            <table className="table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {categories?.length ? (
                        categories.map(cat => (
                            <tr key={cat._id}>
                                <td>{cat.name}</td>
                                <td>
                                    <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() => handleDelete(cat._id)}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="2" className="text-center">
                                No categories found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {/* MODAL */}
            <DynamicFormModal
                show={showModal}
                onHide={() => setShowModal(false)}
                title="Add Blog Category"
                fields={blogCategoryFields}
                initialData={{ name: "" }}
                onSubmit={handleCreate}
            />
        </div>
    );
};

export default BlogCategoryListingPage;